import React from "react";
import {
  Users, Calendar, FileText, Receipt, MessageCircle, ShieldCheck,
} from "lucide-react";

const FEATURES = [
  {
    icon: Users,
    title: "Patient Records",
    text: "Auto-generated UHID from 16022011. Search instantly by name, phone or UHID.",
  },
  {
    icon: FileText,
    title: "FDI Dental Chart",
    text: "Visual per-tooth charting with default & custom conditions. Notes stored per tooth.",
  },
  {
    icon: Calendar,
    title: "Smart Scheduling",
    text: "Book, reschedule, cancel. See today's queue at a glance.",
  },
  {
    icon: MessageCircle,
    title: "WhatsApp Reminders",
    text: "One tap sends a pre-filled confirmation on WhatsApp — no add-ons required.",
  },
  {
    icon: Receipt,
    title: "GST Invoicing",
    text: "Line items, discount & GST. Printable / PDF invoices in one click.",
  },
  {
    icon: ShieldCheck,
    title: "Secure by design",
    text: "Encrypted credentials, isolated data per doctor account. HIPAA-friendly workflow.",
  },
];

const Features = () => (
  <section id="features" className="bg-white py-20 md:py-28">
    <div className="max-w-[1200px] mx-auto px-6">
      <div className="max-w-2xl mb-14">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6] mb-3">
          Everything you need
        </div>
        <h2
          className="text-3xl md:text-[42px] font-extrabold text-[#0F2A5F] leading-tight mb-4"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          One workspace for the whole clinic.
        </h2>
        <p className="text-slate-600 text-lg">
          Purpose-built modules that snap together — no plugins, no chaos.
          Just a fast, focused workflow for dental practice.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f) => (
          <div
            key={f.title}
            className="group bg-white rounded-2xl p-6 border border-slate-200 hover:border-[#14B8A6]/40 hover:shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#E6F7F5] text-[#14B8A6] flex items-center justify-center mb-4 group-hover:bg-[#14B8A6] group-hover:text-white transition-colors">
              <f.icon size={22} />
            </div>
            <h3 className="text-lg font-bold text-[#0F2A5F] mb-2">{f.title}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{f.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
